import React from 'react'
import PropTypes from 'prop-types'
import { Menu } from '@adc/ui-core'
import { track } from '@adc/analytics'
import _ from 'lodash'
import classNames from 'classnames/bind'
import cls from '../styles.scss'
import { MENU_ITEM } from '../constants/classnames'
import { resolveUrl } from '../../../util/url'
const cx = classNames.bind(cls)

const MenuItem = ({
  className,
  children,
  elmId,
  url,
  title,
  trackingName,
  trackingContext,
  baseUrl,
  onClick = _.noop,
  ...props
}) => {
  const handleClick = e => {
    const name =
      trackingName || (typeof title === 'string' ? title.toLowerCase() : null)
    if (name) {
      track('navigation-click', { linkName: name, ...trackingContext })
    }
    onClick(e)
  }

  return (
    <Menu.Item
      href={resolveUrl(url, baseUrl)}
      link
      onClick={handleClick}
      className={cx(className, MENU_ITEM)}
      data-elm-id={elmId}
      {...props}
    >
      {children || title}
    </Menu.Item>
  )
}

MenuItem.propTypes = {
  className: PropTypes.oneOfType([PropTypes.string, PropTypes.array]),
  children: PropTypes.node,
  elmId: PropTypes.string,
  url: PropTypes.string,
  title: PropTypes.node,
  trackingName: PropTypes.string,
  trackingContext: PropTypes.shape({
    linkSource: PropTypes.oneOf(['header', 'dropdown', 'drawer']),
    visibleHeaderLinks: PropTypes.arrayOf(PropTypes.string),
    visibleDropdownLinks: PropTypes.arrayOf(PropTypes.string),
  }),
  baseUrl: PropTypes.string,
  onClick: PropTypes.func,
}

export default MenuItem
